module.exports = __webpack_public_path__ + "static/media/NotoSansJP_regular.11cc76b1.woff";